export const LIST_QUESTIONS = "LIST_QUESTIONS";
export const ANSWER_QUESTION = "ANSWER_QUESTION";
export const GET_ANSWERS = "GET_ANSWERS";
